import React from 'react'
import { FaStar } from "react-icons/fa"
import { images, ReviewSlide } from '../'
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

function Reviews() {
    var sliderSettings = {
        dots: false,
        infinite: false,
        speed: 500,
        slidesToShow: 4,
        slidesToScroll: 1,
        responsive: [
            { breakpoint: 1200, settings: { slidesToShow: 3, slidesToScroll: 3 } },
            { breakpoint: 991, settings: { slidesToShow: 2, slidesToScroll: 2 } },
            { breakpoint: 767, settings: { slidesToShow: 1, slidesToScroll: 1 } },
        ]
    }
    return (
        <div className="seventh-section py-md-5">
            <div className="container py-5">
                <div className="col-md-6 mx-auto text-center">
                    <h1 className='heading mb-0'>
                        See what our past clients have to say about BEEC!
                    </h1>
                    {/* <p className="summary mt-3">
                        Lorem ipsum dolor sit amet, consectetur adipiscing elit. Quisque viverra sed neque at vestibulum. Pellentesque maximus urna magna, nec tempor libero consequat at. Nunc nec.
                    </p> */}
                </div>
                <div className="google-reviews my-3 my-md-5 px-4 px-md-0">
                    <Slider {...sliderSettings}>
                        <ReviewSlide
                            image={images.review1}
                            name={'Noah'}
                            review={"BEEC is such a professional agency!!! It's my great honor and pleasure to be tutored by Jonathan. He's so responsible and reliable!"}
                        // company={company}
                        // time={time}
                        />
                        <ReviewSlide
                            image={images.review2}
                            name={'Shreya'}
                            review={"We absolutely value the mentor/tutor for our daughters. Our HS daughter is getting great advice as she navigates through her sophomore year."}
                        // company={company}
                        // time={time}
                        />
                        <ReviewSlide
                            image={images.review3}
                            name={'Joan P.'}
                            review={"I have searched a lot of agencies to help me apply this year and finally I chose BEEC. They are really nice and professional."}
                        // company={company}
                        // time={time}
                        />
                        <ReviewSlide
                            image={images.review4}
                            name={'Karen W.'}
                            review={"BEEC  helped our duaghter understand what colleges are looking for in these responses and  together in the end, helping her get into her dream school."}
                        // company={company}
                        // time={time}
                        />
                    </Slider>
                </div>
            </div>
        </div>
    )
}

export default Reviews